import React from 'react';
import { Github, Mail } from 'lucide-react';
import useDocumentTitle from '../hooks/useDocumentTitle';

const AboutPage = () => {
  useDocumentTitle('About');
  
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-center mb-8">
          <img 
            src="/profile.jpeg" 
            alt="Balázs Piller" 
            className="w-40 h-40 rounded-full object-cover shadow-lg border-4 border-gray-200"
          />
        </div>
        <h1 className="text-4xl font-semibold mb-8 text-center text-gray-900 tracking-tight">
            <span className="mr-2">👋</span>
            <span>Hi, I'm</span>
            <span className="text-blue-600 ml-2 font-bold">
                Balázs
            </span>
        </h1>

        <div className="bg-white rounded-lg shadow-md p-8 mb-10">
        <p className="text-gray-700 mb-6">
          I'm the creator of <strong>WP-Autoplugin</strong>, a WordPress tool that leverages AI to make plugin creation simpler and more accessible. Over the past several years, I've helped grow a WordPress plugin from 0 to over 3 million active installs alongside an amazing team, while exploring innovative ways to enhance the WordPress ecosystem through AI - from <strong>content creation</strong> to <strong>site management</strong> and <strong>plugin development</strong>.
        </p>

          <h2 className="text-2xl font-semibold mb-4">My Projects</h2>

          <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
            <li>
              <a href="https://hub2wp.com" className="text-blue-600 hover:underline font-medium">hub2wp</a> – A free and open platform (and a companion WordPress plugin) that lets you browse, install, and update plugins directly from GitHub within your WordPress dashboard. It currently lists over 9,000 plugins.
            </li>
            <li>
              <a href="https://webwizwork.com" className="text-blue-600 hover:underline font-medium">WebWizWork.com</a> – An AI-managed WordPress development blog where content creation and site management are fully controlled by talking directly to a Custom GPT, as described in my <a href="https://www.webwizwork.com/articles/chatgpt-set-up-wp-gpt/" className="text-blue-600 hover:underline">detailed tutorial</a>.
            </li>
            <li>
              <a href="https://wordpress.org/plugins/superdraft" className="text-blue-600 hover:underline font-medium">Superdraft AI Toolkit</a> – A free WordPress plugin that enhances content creation with AI-powered tools. Features intelligent writing assistance, automated tag management, smart autocomplete, multi-model AI support, and extensive customization options.
            </li>
            <li>
              <a href="https://github.com/WP-Autoplugin/wp-banana" className="text-blue-600 hover:underline font-medium">WP Nano Banana</a> – A free WordPress plugin that brings AI image generation and editing directly into the native Media Library. It supports dozens of models (including Flux.2 and Seedream 4.5), offers multi-image preview mode, non-destructive editing tools, and full compatibility with Gutenberg, Classic Editor, WooCommerce, Elementor, and more.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">Open Source & Community</h2>
          <p className="text-gray-700 mb-6">
            My projects are open-source. You're welcome to contribute, suggest improvements, or share feedback.
          </p>
          <div className="flex justify-center mb-8">
            <a 
              href="https://github.com/WP-Autoplugin/wp-autoplugin" 
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-lg flex items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Github className="w-5 h-5 mr-2" />
              Contribute on GitHub
            </a>
          </div>

          <h2 className="text-2xl font-semibold mb-4">Get in Touch</h2>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <a 
              href="mailto:connect@webwizwork.com" 
              className="bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded-lg flex items-center justify-center"
            >
              <Mail className="w-5 h-5 mr-2" />
              Email Me
            </a>
            <a 
              href="https://x.com/heyitsbalazs" 
              className="bg-black hover:bg-gray-700 text-white py-2 px-6 rounded-lg flex items-center justify-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="w-4 mr-2 text-xl">𝕏</span>
              @heyitsbalazs
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
